// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ExtendedAddress$PorterinFeature from "../entity/ExtendedAddress.mjs";

var default_customer_address_pickup_address = ExtendedAddress$PorterinFeature.initial_address(undefined);

var default_customer_address_drop_address = ExtendedAddress$PorterinFeature.initial_address(undefined);

var default_customer_address = {
  pickup_address: default_customer_address_pickup_address,
  drop_address: default_customer_address_drop_address,
  name: undefined,
  number: undefined,
  house: undefined
};

var dummy_address = [
  {
    place_id: "1",
    description: "Gateway of India, Mumbai, Maharashtra"
  },
  {
    place_id: "2",
    description: "The Red Fort in Delhi"
  },
  {
    place_id: "3",
    description: "The Taj Mahal in Agra"
  },
  {
    place_id: "4",
    description: "Jaipur, Rajasthan"
  },
  {
    place_id: "5",
    description: "Pune, Maharashtra, India, known for its historical landmarks and as a center for academia and business."
  }
];

var navbar_title = "Select Delivery Vehicle";

var address_edit_button = "Edit";

var payment_method = "Payment Method";

var payment_method_cash = "Cash";

var book_now_button = "Book Now";

var view_breakup_button = "View Breakup";

var offers_text = "Get additional 20% off on this vehicle in the next step.";

var edit_booking_details_button = "Confirm and Proceed";

var edit_address_button = "Change";

var search_results_title = "Search Results";

var search_results_empty_title = "Start searching for places";

var search_results_empty_subtitle = "Search for nearby landmarks, building name, area or street name";

var pickup_address = "Pickup Address";

var dropoff_address = "Dropoff Address";

var form_apartment_name_error_msg = "Please enter valid address";

var form_apartment_name_min_char_error_msg = "Address entered is too short (min 3 char)";

var form_apartment_name_max_char_error_msg = "Address entered is too long (max 50 char)";

var form_special_characters = "Please enter a valid address (no numbers or symbols)";

var error_something_wrong_text = "Something went wrong!";

var error_something_wrong_sub_text = "Sorry, this is embarrassing. Please try again.";

var error_something_wrong_button = "Retry";

var error_unserviceable_text = "Sorry! No service is available";

var error_unserviceable_sub_text = "We do not serve pickup service from this area. Please change the location";

var error_unserviceable_sub_text_pickup = "We do not serve pickup service from this area. Please change the pickup location";

var error_unserviceable_sub_text_dropoff = "We do not serve dropoff service from this area. Please change the dropoff location";

var error_unserviceable_button = "Change Location";

var error_unserviceable_button_pickup = "Change Pickup Location";

var error_unserviceable_button_dropoff = "Change Dropoff Location";

var error_query_params_text = "Data Not Found";

var error_query_params_sub_text = "Please redirect to home.";

var error_query_params_button = "Redirect home";

var error_not_authenticated_text = "Authentication Failed";

var error_not_authenticated_sub_text = "Try signing in again.";

var error_not_authenticated_button = "Login";

var senderLocalStorageKey = "sender";

var receiverLocalStorageKey = "receiver";

var ga_page_landing = "fe_estresult_land";

var ga_back_tap = "fe_estresult_back_tap";

var ga_cta_book_now = "fe_estresult_cta_confirm_tap";

var moe_cta_book_now_parameter = "fe_estresult_cta_confirm_tap_moe";

var ga_cta_book_vehicle_name = "fe_review_cta_confirm_tap";

var moe_cta_book_vehicle_name_parameter = "fe_review_cta_confirm_tap_moe";

var ga_cta_book_select_goods = "fe_review_select_goods_cta_tap";

var moe_cta_book_select_goods_parameter = "fe_review_select_goods_cta_tap_moe";

var ga_error_invalid_token_retry = "fe_estresult_invalid_token_retry_tap";

var ga_error_invalid_pickup_retry = "fe_invalid_pickup_retry_tap";

var ga_error_invalid_drop_retry = "fe_invalid_drop_retry_tap";

var ga_error_failed_api_retry = "fe_failed_api_retry_tap";

var moe_error_failed_api_retry_parameter = "fe_failed_api_retry_tap_moe";

var ga_error_failed_create_trip_retry = "fe_failed_create_trip_retry_tap";

var moe_error_failed_create_trip_retry_parameter = "fe_failed_create_trip_retry_tap_moe";

var confirm_pickup = "fe_confirm_pickup";

var confirm_drop = "fe_confirm_drop";

var use_current_location_click = "fe_use_current_location_click";

var allow_current_location_click = "fe_allow_current_location_click";

var dont_allow_current_location_click = "fe_dont_allow_current_location_click";

var location_accuracy_cg = "location_accuracy_cg";

var location_accuracy_tg = "location_accuracy_tg";

var arrowRightIcon = "/assets/icons/common/arrows/east.svg";

var arrowRightAlt = "Arrow Right Icon";

var shopIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/Shop_Frame_d351e39899/Shop_Frame_d351e39899.svg";

var shopIconAlt = "Shop Icon";

var retailBookingBanner = "https://dom-content-vault-prod-cdn-assets.porter.in/Retail_Booking_Banner_8dc05aa3a9/Retail_Booking_Banner_8dc05aa3a9.webp";

var retailBookingBannerAlt = "Retail Booking Banner";

var retailBookingCtaText = "Enter your address";

var addressInputValidatorMsg = "Please enter valid address";

var housePlaceholder = "House / Apartment (optional)";

var namePlaceholder = "Name";

var mobilePlaceholder = "Mobile";

var twowheeletCategoryGA = "2W";

var trucksCategoryGA = "Trucks";

var partloadCategoryGA = "Partload";

var ga_fare_estimate_successful = "Get Trip Estimate Successful";

var ga_fare_estimate_form_validation = "Get Trip Estimate Validation Successful";

var ga_fare_estimate_successful_event_parameter = "GTES Event Paramenter";

var ga_fare_estimate_form_validation_error = "Get Trip Estimate Validation Error";

var gtes_unregistered_action_name = "GTES_Unregistered";

var moe_fare_estimate_result_cta_confirm = "fe_est_result_cta_confirm";

export {
  navbar_title ,
  address_edit_button ,
  payment_method ,
  payment_method_cash ,
  book_now_button ,
  view_breakup_button ,
  offers_text ,
  edit_booking_details_button ,
  edit_address_button ,
  search_results_title ,
  search_results_empty_title ,
  search_results_empty_subtitle ,
  pickup_address ,
  dropoff_address ,
  form_apartment_name_error_msg ,
  form_apartment_name_min_char_error_msg ,
  form_apartment_name_max_char_error_msg ,
  form_special_characters ,
  error_something_wrong_text ,
  error_something_wrong_sub_text ,
  error_something_wrong_button ,
  error_unserviceable_text ,
  error_unserviceable_sub_text ,
  error_unserviceable_sub_text_pickup ,
  error_unserviceable_sub_text_dropoff ,
  error_unserviceable_button ,
  error_unserviceable_button_pickup ,
  error_unserviceable_button_dropoff ,
  error_query_params_text ,
  error_query_params_sub_text ,
  error_query_params_button ,
  error_not_authenticated_text ,
  error_not_authenticated_sub_text ,
  error_not_authenticated_button ,
  senderLocalStorageKey ,
  receiverLocalStorageKey ,
  ga_page_landing ,
  ga_back_tap ,
  ga_cta_book_now ,
  moe_cta_book_now_parameter ,
  ga_cta_book_vehicle_name ,
  moe_cta_book_vehicle_name_parameter ,
  ga_cta_book_select_goods ,
  moe_cta_book_select_goods_parameter ,
  ga_error_invalid_token_retry ,
  ga_error_invalid_pickup_retry ,
  ga_error_invalid_drop_retry ,
  ga_error_failed_api_retry ,
  moe_error_failed_api_retry_parameter ,
  ga_error_failed_create_trip_retry ,
  moe_error_failed_create_trip_retry_parameter ,
  confirm_pickup ,
  confirm_drop ,
  use_current_location_click ,
  allow_current_location_click ,
  dont_allow_current_location_click ,
  location_accuracy_cg ,
  location_accuracy_tg ,
  arrowRightIcon ,
  arrowRightAlt ,
  shopIcon ,
  shopIconAlt ,
  retailBookingBanner ,
  retailBookingBannerAlt ,
  retailBookingCtaText ,
  addressInputValidatorMsg ,
  housePlaceholder ,
  namePlaceholder ,
  mobilePlaceholder ,
  twowheeletCategoryGA ,
  trucksCategoryGA ,
  partloadCategoryGA ,
  default_customer_address ,
  dummy_address ,
  ga_fare_estimate_successful ,
  ga_fare_estimate_form_validation ,
  ga_fare_estimate_successful_event_parameter ,
  ga_fare_estimate_form_validation_error ,
  gtes_unregistered_action_name ,
  moe_fare_estimate_result_cta_confirm ,
}
/* default_customer_address Not a pure module */
